document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    const sortBtn = event.target.closest(".sort_by_btn");
    const productGrid = document.querySelector(".main_collection_product_grid");
    if (sortBtn) {
      if (productGrid) {
        productGrid.classList.add("show_sort");
        document.body.classList.add("overflow-hidden-mobile");
      }
    }
    const sortClose = event.target.closest(".sort_close ");
    if (sortClose) {
      if (productGrid) {
        productGrid.classList.remove("show_sort");
        document.body.classList.remove("overflow-hidden-mobile");
      }
    }
    const sortOverlay = event.target.closest(".sort_overlay ");
    if (sortOverlay) {
      if (productGrid) {
        productGrid.classList.remove("show_sort");
        document.body.classList.remove("overflow-hidden-mobile");
      }
    }
  });

  const outStock = document.querySelectorAll(".out_of_stock");
  const outTrigger = document.querySelector(".BIS_trigger");

  if (outStock.length > 0 && outTrigger) {
    outStock.forEach((item) => {
      item.addEventListener("click", function () {
        const selectedVariantId = this.getAttribute("data-id");
        outTrigger.setAttribute("data-id", selectedVariantId);
      });
    });
  }

  const switcherButton = document.querySelector(".gridViewDesktopButton");
const mobileSwitchBtn = document.querySelector(".gridViewMobileButton");
const gridItems = document.querySelectorAll(".main_collection_product_grid");

const gridClasses = ["grid_view2", "grid_view3", "grid_view4", "grid_view6"];
const mobileGridClasses = ["big", "small", "smallest"];

// --- Set default values if localStorage is empty ---
if (localStorage.getItem("gridViewIndex") === null) {
  localStorage.setItem("gridViewIndex", gridClasses.indexOf("grid_view3")); // default desktop grid 3
}
if (localStorage.getItem("mobileGridIndex") === null) {
  localStorage.setItem("mobileGridIndex", mobileGridClasses.indexOf("small")); // default mobile small
}

// Get saved indexes from localStorage
let gridViewIndex = parseInt(localStorage.getItem("gridViewIndex"));
let mobileGridIndex = parseInt(localStorage.getItem("mobileGridIndex"));

function applyView(classes, index, element, items, storageKey) {
  if (!element) return;

  let newIndex = index % classes.length;

  // Remove all possible classes first
  element.classList.remove(...classes);
  items.forEach((item) => item.classList.remove(...classes));

  // Add the correct class
  element.classList.add(classes[newIndex]);
  items.forEach((item) => item.classList.add(classes[newIndex]));

  // Save in localStorage
  localStorage.setItem(storageKey, newIndex);
}

function updateGridView() {
  gridViewIndex = (gridViewIndex + 1) % gridClasses.length;
  applyView(gridClasses, gridViewIndex, switcherButton, gridItems, "gridViewIndex");
}

function updateMobileView() {
  mobileGridIndex = (mobileGridIndex + 1) % mobileGridClasses.length;
  applyView(mobileGridClasses, mobileGridIndex, mobileSwitchBtn, gridItems, "mobileGridIndex");
}

// --- INIT (page load or collection change) ---
if (switcherButton) {
  switcherButton.addEventListener("click", updateGridView);
  applyView(gridClasses, gridViewIndex, switcherButton, gridItems, "gridViewIndex");
}

if (mobileSwitchBtn) {
  mobileSwitchBtn.addEventListener("click", updateMobileView);
  applyView(mobileGridClasses, mobileGridIndex, mobileSwitchBtn, gridItems, "mobileGridIndex");
}

  //---------------------------------------------------------------
  const filterForm = document.querySelector("form[data-facet-form]");
  const filteInner = document.querySelector(".mobile-facets__inner");
  const clearWrapper = document.querySelector(".custom-facets__clear-wrapper");
  function updateFilterClasses() {
    const checkedInputs = filterForm.querySelectorAll(
      'input[type="checkbox"]:checked'
    );
    if (checkedInputs.length > 0) {
      filteInner.classList.add("is-filter-active");
      clearWrapper.classList.remove("hidden");
    } else {
      filteInner.classList.remove("is-filter-active");
      clearWrapper.classList.add("hidden");
    }
  }
  updateFilterClasses();
  document.addEventListener("click", (event) => {
    if (event.target.matches(".mobile-facets__clear")) {
      filteInner.classList.remove("is-filter-active");
      clearWrapper.classList.add("hidden");
    }
  });
  filterForm.addEventListener("change", function () {
    updateFilterClasses();
  });
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
window.addEventListener('beforeunload', () => {
  sessionStorage.setItem('collectionScrollY', window.scrollY);
});
});